@if (isLoading()) {
  <sd-skeleton
    [appearance]="SkeletonAppearanceEnum.square"
    [sizeChangeMobile]="false"
    [count]="1"
  />
} @else if (isSmall()) {
  @if (onSale() && hasPrice()) {
    @if (isInStock()) {
      @let isIcon = isMobile();
      <button sd-button type="button" [brand]="brand()" icon="icon-cart" [isIcon]="isIcon" (click)="addToCart()" data-testid="cart1">
        <span class="{{isIcon ? 'is-visually-hidden' : ''}}">
          {{('actions.cart.add' | translate) || '...'}}
          <span class="is-visually-hidden">{{productName()}}</span>
        </span>
      </button>
    } @else {
      <button sd-button type="button" [brand]="brand()" [isSecondary]="true" (click)="stockNotify()" data-testid="stock1">
        <span>{{('product.stock.notify' | translate) || '...'}}</span>
        <span class="is-visually-hidden">{{productName()}}</span>
      </button>
    }
  }
} @else {
  @if (isProductComparator() && !horizontalParentLayout()) {
    <sd-form checkbox
      (checkedChange)="addToComparator($event)"
      [(checked)]="isCompared"
      [labelTitle]="(('comparator.add' | translate) || '...') + '<span class=is-visually-hidden>' + productName() + '</span>'"
      nameField="addToCompare"
      data-testid="checkbox"
    />
  }
  <div class="c__button-container">
    @if (onSale() && hasPrice()) {
      @if (isInStock()) {
        <button sd-button type="button" class="c__add-to-cart" [brand]="brand()" icon="icon-cart" (click)="addToCart()" data-testid="cart2">
          <span>{{('actions.cart.add' | translate) || '...'}}</span>
        </button>
      } @else {
        <button sd-button type="button" [brand]="brand()" [isSecondary]="true" (click)="stockNotify()" data-testid="stock2">
          <span>{{('product.stock.notify' | translate) || '...'}}</span>
          <span class="is-visually-hidden">{{productName()}}</span>
        </button>
      }
    }
    @if (showWishList) {
      <button sd-button-icon
        type="button"
        [brand]="brand()"
        [icon]="favoriteIcon()"
        (click)="addToFavorite()"
        [buttonIconTitle]="(isInFavorite() ? (('actions.wishlist.remove' | translate) || '...') : ('actions.wishlist.add' | translate)) + ' ' + productName()"
        data-testid="favorite"
      ></button>
    }
  </div>
}
